<small *ngIf="showMaxLengthCounter()" class="text-blue-600">
  Χαρακτήρες που απομένουν: {{ getRemainingCharCount() }}
</small>
